<div class="container">

  <h1> CERS Notification verification </h1>
  <app-aa-spinner [loading]="isLoading"></app-aa-spinner>
  @if (notificationRecords.profiles.length) {
    <div>
      <h4> Select a profile to view notification settings </h4>
      <select class="form-control dropdown" [(ngModel)]="selectedProfile" (change)="getProfileNotificationMethods()">
        @for (profile of notificationRecords.profiles; track profile) {
          <option
            [selected]="profile.profileSk === selectedProfile.profileSk" [ngValue]="profile">{{profile.profileName}}
          </option>
        }
      </select>
    </div>
  }
  @if (!notificationRecords.profiles.length && !isLoading) {
    <div>
      <h4> No notification profiles available </h4>
    </div>
  }
  @if (notificationMethods.length) {
    <div>
      <table>
        <tr>
          <th class="selectRadio">
            <h4>Select</h4>
          </th>
          <th>
            <h4>Message type</h4>
          </th>
          <th>
            <h4>Vendor name</h4>
          </th>
          <th>
            <h4>Email prefix/Phone number</h4>
          </th>
          <th>
            <h4>Last verified date</h4>
          </th>
        </tr>
        @for (record of notificationMethods; track record) {
          <tr>
            <td class="radio-btns">
              <input type="radio" [checked]="record.selected" name="record.notificationSk" value="record.notificationSk" (change)="selectionChanged(record);">
            </td>
            <td>
              <select class="form-control dropdown" name="record.messageType" [(ngModel)]="record.messageTypeSk" (change)="selectionChanged(record);">
                @for (mt of messageTypes; track mt) {
                  <option [ngValue]="mt.messageTypeSk"
                    [selected]="record.messageType === mt.messageType">
                    {{mt.messageType}}
                  </option>
                }
              </select>
            </td>
            <td>
              <select class="form-control dropdown" name="record.vendorName" [(ngModel)]="record.vendorName" (change)="selectionChanged(record);">
                @for (v of vendors; track v) {
                  <option [ngValue]="v.vendorName"
                    [selected]="record.vendorName === v.vendorName">
                    {{v.vendorName}}
                  </option>
                }
              </select>
            </td>
            <td>
              <span [ngClass]="{'email-input': record.isEmail}">
                <input type="text" class="form-control" name="record.notificationValue"
                  (change)="selectionChanged(record);" [formControl]="record.validationRules" />
                @if (record.isEmail) {
                  <div class="email-ext">{{'@' + record.vendorExt}}</div>
                }
              </span>
              @if (record.validationRules.errors) {
                <span>
                  @if (record.validationRules.errors.pattern) {
                    <span class="errorText">Must be a valid
                    phone</span>
                  }
                  @if (record.validationRules.errors.required) {
                    <span class="errorText">Cannot be blank</span>
                  }
                  @if (record.validationRules.errors.prefix) {
                    <span class="errorText">Email prefix only</span>
                  }
                  @if (record.validationRules.errors.invalid) {
                    <span class="errorText">Must be a valid
                    email</span>
                  }
                </span>
              }
            </td>
            <td>
              <label>{{record.lastVerifiedDate }}</label>
            </td>
          </tr>
        }
      </table>
      <table>
        <tr>
          <td>
            <button type="button" class="btn-primary" (click)="ConfirmAllPopup()" [disabled]="confirmAllDisabled || updateLoading">Confirm all</button>
            <button type="button" class="btn-primary" (click)="ConfirmSave()" [disabled]="updateLoading">Save</button>
            <button type="button" class="btn-primary" (click)="getNotificationRecords()" [disabled]="!selectedMethod || updateLoading">Undo All</button>
            <button type="button" class="btn-primary" (click)="ConfirmDelete()" [disabled]="updateLoading">Delete</button>
            <button type="button" class="btn-primary" (click)="ShowAttributes()" [disabled]="updateLoading">Attributes</button>
          </td>
          <td class="message-text">
            <app-aa-spinner-no-logo [loading]="updateLoading"></app-aa-spinner-no-logo>
            <label>
              <h4>{{responseMessage}}</h4>
            </label>
          </td>
        </tr>
      </table>
      <table>
        @if (selectedMethod && showFactor && selectedMethod.notificationFactors.length >0) {
          <div>
            <tr>
              <th>Factor type</th>
              <th>Description</th>
            </tr>
            @for (notificationFactor of selectedMethod.notificationFactors; track notificationFactor) {
              <tr>
                <td>{{notificationFactor.factorType}}</td>
                <td>{{notificationFactor.hierarchyDescription}}</td>
              </tr>
            }
          </div>
        }
        @if (selectedMethod && showFactor && selectedMethod.notificationFactors.length === 0 ) {
          <div>
            <label>No Factors</label>
          </div>
        }
      </table>
    </div>
  }
</div>
<app-confirmation-popup #saveConfirmation [title]="'Confirm to save?'" [message]="'This action is going to save the selected notification method. Do you want to proceed?'" (callAction)="Save()">
</app-confirmation-popup>
<app-confirmation-popup #deleteConfirmation [title]="'Confirm to delete?'" [message]="'This action will send a delete request to your Notification Adminitrator. Do you want to proceed?'" (callAction)="Delete()">
</app-confirmation-popup>
<app-confirmation-popup #confirmAll [title]="'Confirm all notifications?'" [message]="'This action is going to mark all the notification as confirmed and reload all notifications. Ensure that changes have been saved. Do you want to proceed?'" (callAction)="ConfirmAll()">
</app-confirmation-popup>
